import Avatar from './components/Avatar';
import React, { useEffect, useState } from 'react';

const ClansList = ({ setCurrentPage, setSelectedClan, formatNumber }) => {
  const [clans, setClans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClans = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/list`);
        if (!response.ok) {
          throw new Error('Ошибка получения данных с сервера');
        }
        const data = await response.json();
        setClans(data);
      } catch (error) {
        console.error('Ошибка получения данных о кланах:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClans();
  }, []);

  return (
    <div className="container_">
      {loading ? (
        <p>Загрузка...</p>
      ) : clans.length === 0 ? (
        <p>Нет доступных кланов</p>
      ) : (
        clans.map((clan) => (
          <div
            key={clan.id}
            className="scoreboard"
            onClick={() => {
              setSelectedClan(clan.id); // Передаем весь объект клана
              setCurrentPage('clans_info'); // Переход на страницу информации
            }}
          >
            <Avatar clanId={clan.id} src={clan.avatar_url || '/assets/imgur/C3a3S1X.png'} alt="Аватар" className="avatar" onError={(e) => (e.target.src = '/assets/imgur/C3a3S1X.png')} />
            <div className="info">
              <div className="name">{clan.name}</div>
              <div className="progressd">{clan.member_count}/20</div>
            </div>
            <div className="trophy-section">
              <span className="trophy">🏆</span>
              <span className="points">{formatNumber(clan.total_clicks || 0).toLocaleString()}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ClansList;
